import React, { Fragment, useCallback, useEffect, useState } from 'react'
import UserLayout from '../../layouts/UserLayout'
import { useNavigate, useParams } from 'react-router-dom'
import { getFromStorage } from '../../utils/storage'
import axios from 'axios'
import { DOMAIN } from '../../utils/api'
import { handleError } from '../../utils/error'
import {
	Backdrop,
	Box,
	Card,
	Chip,
	CircularProgress,
	Divider,
	FormControl,
	InputLabel,
	MenuItem,
	OutlinedInput,
	Select,
	Typography,
	useMediaQuery,
} from '@mui/material'
import PickDateWithoutShiftGrow from '../../components/PickDateWithoutShiftGrow'
import { transformDetailWithPhone } from '../../utils/transformDetail'
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt'
import EditIcon from '@mui/icons-material/Edit'
import { currentUserActions } from '../../redux/store'
import { useDispatch } from 'react-redux'
import { mainBlue, mainGreen, mainPurple, mainRed } from '../../utils/color'

export default function StatisticsSMToday() {
	const dispatch = useDispatch()
	const { storeId } = useParams()
	const navigate = useNavigate()
	const mediaMd = useMediaQuery('(min-width:768px)')
	const [statistics, setStatistics] = useState([])

	const [loadingStatistics, setLoadingStatistics] = useState(true)
	const [showBackdrop, setShowBackdrop] = useState(false)
	const [showDetailBackdrop, setShowDetailBackdrop] = useState(false)
	const [showDeleteDetailBackdrop, setShowDeleteDetailBackdrop] = useState(false)
	const [orderDetail, setOrderDetail] = useState()
	const [deleteOrderDetail, setDeleteOrderDetail] = useState()
	const [updateHistory, setUpdateHistory] = useState()
	const [userFilter, setUserFilter] = useState('')
	const [orderFilter, setOrderFilter] = useState('')

	const token = getFromStorage('current-user')?.accessToken
	const today = new Date()
	const [timePick, setTimePick] = useState({
		date: today.getDate()?.toString(),
		month: (today.getMonth() + 1)?.toString(),
		year: today.getFullYear()?.toString(),
	})
	const [shift, setShift] = useState({ morning: true, afternoon: false })
	const [currentImage, setCurrentImage] = useState(null)
	const [isViewerOpen, setIsViewerOpen] = useState(false)

	const openImageViewer = (photo) => {
		setCurrentImage(photo)
		setIsViewerOpen(true)
	}

	const closeImageViewer = () => {
		setCurrentImage(null)
		setIsViewerOpen(false)
	}

	const [users, setUsers] = useState([])
	const getUsers = useCallback(
		async function () {
			try {
				const response = await axios({
					url: `${DOMAIN}/admin/user/store/${storeId}`,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				setUsers(response.data)
			} catch (error) {
				handleError(error)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[token, dispatch, navigate, storeId],
	)

	useEffect(() => {
		getUsers()
	}, [getUsers])

	const getStatistics = useCallback(
		async function () {
			const { date, month, year } = timePick
			try {
				const response = await axios({
					url: `${DOMAIN}/admin/statistics/store/today/${storeId}?shift=${shift.morning}&date=${date}&month=${month}&year=${year}&user=${userFilter}`,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				setStatistics(response.data)
				setLoadingStatistics(false)
			} catch (error) {
				handleError(error)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[token, navigate, storeId, timePick, shift.morning, dispatch, userFilter],
	)

	useEffect(() => {
		getStatistics()
	}, [getStatistics])

	const setTime = (time) => {
		setTimePick(time)
	}

	const handleChangeUser = (e) => {
		setUserFilter(e.target.value)
	}

	const handleChangeOrder = (e) => {
		setOrderFilter(e.target.value)
	}

	return (
		<UserLayout>
			{loadingStatistics ? (
				<Box
					sx={{
						marginTop: '120px',
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
					}}>
					<CircularProgress sx={{ color: mainGreen }} />
				</Box>
			) : (
				<Box>
					<Backdrop
						sx={{
							color: '#fff',
							zIndex: 999,
							left: mediaMd ? 300 : 0,
						}}
						open={isViewerOpen}
						onClick={closeImageViewer}>
						<img
							loading='lazy'
							src={currentImage}
							alt='attach'
							style={{
								maxHeight: '70%',
								maxWidth: '90%',
							}}
							onClick={(e) => {
								e.stopPropagation()
							}}
						/>
					</Backdrop>
					<Box sx={{ textAlign: 'center' }}>
						<Card
							sx={{
								padding: '10px',
								margin: '0 auto',
								maxWidth: 992,
							}}>
							<Typography
								sx={{
									fontWeight: 'bold',
								}}>
								{statistics?.store?.toUpperCase()}
							</Typography>
							<Box display='flex' justifyContent='center' alignItems='center'>
								<FormControl sx={{ minWidth: 110, mt: 1, mb: 1, mr: 1 }} size='small'>
									<InputLabel id='select-label'>Nhân viên</InputLabel>
									<Select
										id='user-select'
										name='user'
										value={userFilter}
										labelId='select-label'
										input={<OutlinedInput label='Nhân viên' />}
										onChange={handleChangeUser}>
										<MenuItem value=''>
											<em>- Tất cả -</em>
										</MenuItem>
										{users?.map((user, index) => {
											return (
												<MenuItem key={index} value={user.id}>
													{user?.name}
												</MenuItem>
											)
										})}
									</Select>
								</FormControl>
								<FormControl sx={{ minWidth: 110, mt: 1, mb: 1 }} size='small'>
									<InputLabel id='select-label'>Đơn hàng</InputLabel>
									<Select
										id='order-select'
										name='order'
										value={orderFilter}
										labelId='select-label'
										input={<OutlinedInput label='Đơn hàng' />}
										onChange={handleChangeOrder}>
										<MenuItem value=''>
											<em>- Tất cả -</em>
										</MenuItem>
										<MenuItem value='normal'>Thường</MenuItem>
										<MenuItem value='transfer'>CK</MenuItem>
										<MenuItem value='quickPurchase'>Nhanh</MenuItem>
										<MenuItem value='app'>App</MenuItem>
										<MenuItem value='send'>Chuyển</MenuItem>
										<MenuItem value='receive'>Nhận</MenuItem>
										<MenuItem value='cancel'>Hủy</MenuItem>
							
									</Select>
								</FormControl>
							</Box>
							<PickDateWithoutShiftGrow time={timePick} setTime={setTime} />
							<Box display='flex' justifyContent='center' sx={{ mt: 2 }}>
								<Chip
									onClick={() => {
										if (shift.morning === false) {
											setShift({ morning: true, afternoon: false })
										}
									}}
									size='small'
									sx={{
										cursor: 'pointer',
										mr: 1,
										background: shift.morning ? mainGreen : undefined,
										color: shift.morning ? '#fff' : '#000',
										'&:hover': {
											background: shift.morning ? mainGreen : undefined,
											color: shift.morning ? '#fff' : '#000',
										},
									}}
									label={
										<Typography
											sx={{
												fontSize: '14px',
												display: 'flex',
												justifyContent: 'center',
												alignItems: 'center',
												lineHeight: 1.3,
											}}>
											Sáng
										</Typography>
									}
								/>
								<Chip
									onClick={() => {
										if (shift.afternoon === false) {
											setShift({ morning: false, afternoon: true })
										}
									}}
									size='small'
									sx={{
										cursor: 'pointer',
										background: shift.afternoon ? mainGreen : undefined,
										color: shift.afternoon ? '#fff' : '#000',
										'&:hover': {
											background: shift.afternoon ? mainGreen : undefined,
											color: shift.afternoon ? '#fff' : '#000',
										},
										mr: 1,
									}}
									label={
										<Typography
											sx={{
												fontSize: '14px',
												display: 'flex',
												justifyContent: 'center',
												alignItems: 'center',
												lineHeight: 1.3,
											}}>
											Chiều
										</Typography>
									}
								/>
								<Chip
									onClick={() => {
										if (orderFilter !== 'send') {
											setOrderFilter('send')
										} else {
											setOrderFilter('')
										}
									}}
									size='small'
									sx={{
										cursor: 'pointer',
										mr: 1,
										background: orderFilter === 'send' ? mainPurple : undefined,
										color: orderFilter === 'send' ? '#fff' : '#000',
										'&:hover': {
											background: orderFilter === 'send' ? mainPurple : undefined,
											color: orderFilter === 'send' ? '#fff' : '#000',
										},
									}}
									label={
										<Typography
											sx={{
												fontSize: '14px',
												display: 'flex',
												justifyContent: 'center',
												alignItems: 'center',
											}}>
											Chuyển
										</Typography>
									}
								/>
								<Chip
									onClick={() => {
										if (orderFilter !== 'receive') {
											setOrderFilter('receive')
										} else {
											setOrderFilter('')
										}
									}}
									size='small'
									sx={{
										cursor: 'pointer',
										background: orderFilter === 'receive' ? mainBlue : undefined,
										color: orderFilter === 'receive' ? '#fff' : '#000',
										'&:hover': {
											background: orderFilter === 'receive' ? mainBlue : undefined,
											color: orderFilter === 'receive' ? '#fff' : '#000',
										},
										mr: 1,
									}}
									label={
										<Typography
											sx={{
												fontSize: '14px',
												display: 'flex',
												justifyContent: 'center',
												alignItems: 'center',
											}}>
											Nhận
										</Typography>
									}
								/>
								<Chip
									onClick={() => {
										if (orderFilter !== 'cancel') {
											setOrderFilter('cancel')
										} else {
											setOrderFilter('')
										}
									}}
									size='small'
									sx={{
										cursor: 'pointer',
										background: orderFilter === 'cancel' ? mainRed : undefined,
										color: orderFilter === 'cancel' ? '#fff' : '#000',
										'&:hover': {
											background: orderFilter === 'cancel' ? mainRed : undefined,
											color: orderFilter === 'cancel' ? '#fff' : '#000',
										},
									}}
									label={
										<Typography
											sx={{
												fontSize: '14px',
												display: 'flex',
												justifyContent: 'center',
												alignItems: 'center',
											}}>
											Hủy
										</Typography>
									}
								/>
							</Box>
						</Card>
						{statistics?.detail?.length === 0 && statistics?.deletedDetail?.length === 0 && (
							<Typography sx={{ marginTop: '50px' }}>Chưa có dữ liệu</Typography>
						)}
						<Box
							overflow='auto'
							sx={{
								padding: '0 1px',
								margin: '0 auto',
								maxWidth: 992,
								position: 'fixed',
								top: mediaMd ? 245 : 235,
								left: mediaMd ? 300 : 0,
								right: 0,
								bottom: 0,
							}}>
							{statistics?.deletedDetail?.length > 0 &&
								orderFilter === '' &&
								statistics?.deletedDetail.map((order, index) => {
									return (
										<Card
											key={index}
											sx={{
												marginBottom: '10px',
												padding: '10px',
												textAlign: 'left',
											}}>
											<Typography
												sx={{
													background: mainRed,
													color: '#fff',
													padding: '0 10px',
													display: 'inline-block',
													borderRadius: '10px',
													mb: 1,
												}}>
												<b>Người xóa: </b>
												{order.order?.deletor?.name}
											</Typography>
											<Typography
												sx={{
													display: 'inline-flex',
													mb: 1,
													ml: 1,
													textDecoration: 'underline',
													color: '#1939B7',
													cursor: 'pointer',
													fontStyle: 'italic',
												}}
												onClick={() => {
													setDeleteOrderDetail(order)
													setShowDeleteDetailBackdrop(true)
												}}>
												Chi tiết
											</Typography>
											<Typography>
												<b>Thời gian xóa: </b>
												{order.order.timeStamp}
											</Typography>
											<Divider sx={{ mb: 1, mt: 1 }} />
											<Typography>
												<b>Ca: </b>
												{order.order.orderData.shiftCode}
												{order.order.orderData.shiftIndex} - {order.order.orderData.shiftDay}
											</Typography>
											<Typography>
												<b>Khối lượng: </b>
												{order.order.orderData.quantity}kg - <b>Tiền: </b>
												{order.order.orderData.totalPrice.toLocaleString()}đ
											</Typography>
											<Typography>
												<b>Thông tin: </b>
												{order.order.orderData.detail && (
													<span
														dangerouslySetInnerHTML={{
															__html: transformDetailWithPhone(order.order.orderData.detail),
														}}></span>
												)}
											</Typography>
										</Card>
									)
								})}
							<Backdrop
								sx={{
									color: '#fff',
									zIndex: 999,
									left: mediaMd ? 300 : 0,
								}}
								open={showDeleteDetailBackdrop}
								onClick={() => {
									setShowDeleteDetailBackdrop(false)
								}}>
								<Box>
									<Box
										sx={{
											background: '#fff',
											color: '#000',
											maxHeight: '400px',
											overflow: 'auto',
											borderRadius: '5px',
										}}>
										<Box
											sx={{
												padding: '10px',
												textAlign: 'left',
											}}>
											<Typography
												sx={{
													background: mainRed,
													color: '#fff',
													padding: '0 10px',
													display: 'inline-block',
													borderRadius: '10px',
													mb: 1,
												}}>
												<b>Người xóa: </b>
												{deleteOrderDetail?.order.deletor.name}
											</Typography>
											<Typography>
												<b>Thời gian xóa: </b>
												{deleteOrderDetail?.order.timeStamp}
											</Typography>
											<Typography>
												<b>Ca: </b>
												{deleteOrderDetail?.order.orderData.shiftCode}
												{deleteOrderDetail?.order.orderData.shiftIndex} - {deleteOrderDetail?.order.orderData.shiftDay}
											</Typography>
											<Divider sx={{ mb: 1, mt: 1 }} />
											<Typography>
												<b>Người tạo: </b>
												{deleteOrderDetail?.creator?.name}
											</Typography>
											<Typography>
												<b>Thời gian tạo: </b>
												{deleteOrderDetail?.order.orderData.creator?.createdAt}
											</Typography>
											{deleteOrderDetail?.producer?.name && (
												<>
													<Divider sx={{ mb: 1, mt: 1 }} />
													<Typography>
														<b>Người xử lý: </b>
														{deleteOrderDetail?.producer?.name || 'chưa có'}
													</Typography>
													<Typography>
														<b>Nhận xử lý: </b>
														{deleteOrderDetail?.order.orderData.producer?.produceStart || 'chưa có'}
													</Typography>
													<Typography>
														<b>Hoàn thành xử lý: </b>
														{deleteOrderDetail?.order.orderData.producer?.produceEnd || 'chưa có'}
													</Typography>
												</>
											)}
											{deleteOrderDetail?.shipper?.name && (
												<>
													<Divider sx={{ mb: 1, mt: 1 }} />

													<Typography>
														<b>Người giao hàng: </b>
														{deleteOrderDetail?.shipper?.name || 'chưa có'}
													</Typography>
													<Typography>
														<b>Nhận giao hàng: </b>
														{deleteOrderDetail?.order.orderData.shipper?.shipStart || 'chưa có'}
													</Typography>
												</>
											)}
										</Box>
									</Box>
								</Box>
							</Backdrop>
							<Backdrop
								sx={{
									color: '#fff',
									zIndex: 999,
									left: mediaMd ? 300 : 0,
								}}
								open={showDetailBackdrop}
								onClick={() => {
									setShowDetailBackdrop(false)
								}}>
								<Box>
									<Box
										sx={{
											background: '#fff',
											color: '#000',
											maxHeight: '400px',
											overflow: 'auto',
											borderRadius: '5px',
										}}>
										<Box
											sx={{
												padding: '10px',
												textAlign: 'left',
											}}>
											<Box display='flex' alignItems='center'>
												<Typography
													sx={{
														display: 'inline-flex',
														padding: '0 10px',
														background:
															orderDetail?.detail.status === 'transfer'
																? mainPurple
																: orderDetail?.detail.status === 'pending-delete-produce' ||
																	  orderDetail?.detail.status === 'pending-delete-ship' ||
																	  orderDetail?.detail.status === 'pending-delete-success' ||
																	  orderDetail?.detail.status === 'confirm-delete-produce' ||
																	  orderDetail?.detail.status === 'confirm-delete-ship' ||
																	  orderDetail?.detail.status === 'confirm-delete-success'
																	? mainRed
																	: mainGreen,
														color: '#fff',
														borderRadius: '10px',
														mb: 1,
													}}>
													{' '}
													{orderDetail?.detail.shiftCode}
													{orderDetail?.detail.shiftIndex} -
													{orderDetail?.detail.status === 'transfer' &&
														` chuyển đến ${orderDetail?.detail.toStore?.name}`}
													{orderDetail?.detail.status === 'create' && ' chờ xử lý'}
													{orderDetail?.detail.status === 'pending-produce' && ' chờ xác nhận xử lý'}
													{(orderDetail?.detail.status === 'pending-delete-produce' ||
														orderDetail?.detail.status === 'pending-delete-ship' ||
														orderDetail?.detail.status === 'pending-delete-success') &&
														' chờ hủy đơn'}
													{(orderDetail?.detail.status === 'confirm-delete-produce' ||
														orderDetail?.detail.status === 'confirm-delete-ship' ||
														orderDetail?.detail.status === 'confirm-delete-success') &&
														' đã hủy'}
													{orderDetail?.detail.status === 'produce' &&
														!orderDetail?.detail.producer.produceEnd &&
														' đang xử lý'}
													{orderDetail?.detail.status === 'produce' &&
														orderDetail?.detail.producer.produceEnd &&
														' đã xử lý'}
													{orderDetail?.detail.status === 'ship' &&
														!orderDetail?.detail.shipper.produceEnd &&
														' đang giao'}
													{orderDetail?.detail.status === 'success' && ' giao thành công'}
												</Typography>
												{orderDetail?.detail?.toStoreOrder && (
													<Typography
														sx={{
															display: 'inline-flex',
															padding: '0 10px',
															ml: 1,
															background:
																orderDetail?.detail?.toStoreOrder?.status === 'transfer'
																	? mainPurple
																	: orderDetail?.detail?.toStoreOrder?.status === 'pending-delete-produce' ||
																		  orderDetail?.detail?.toStoreOrder?.status === 'pending-delete-ship' ||
																		  orderDetail?.detail?.toStoreOrder?.status === 'pending-delete-success' ||
																		  orderDetail?.detail?.toStoreOrder?.status === 'confirm-delete-produce' ||
																		  orderDetail?.detail?.toStoreOrder?.status === 'confirm-delete-ship' ||
																		  orderDetail?.detail?.toStoreOrder?.status === 'confirm-delete-success'
																		? mainRed
																		: mainGreen,
															color: '#fff',
															borderRadius: '10px',
															mb: 1,
														}}>
														{' '}
														{orderDetail?.detail?.toStoreOrder?.shiftCode}
														{orderDetail?.detail?.toStoreOrder?.shiftIndex} -
														{orderDetail?.detail?.toStoreOrder?.status === 'create' && ' chờ xử lý'}
														{orderDetail?.detail?.toStoreOrder?.status === 'pending-produce' && ' chờ xác nhận xử lý'}
														{(orderDetail?.detail?.toStoreOrder?.status === 'pending-delete-produce' ||
															orderDetail?.detail?.toStoreOrder?.status === 'pending-delete-ship' ||
															orderDetail?.detail?.toStoreOrder?.status === 'pending-delete-success') &&
															' chờ hủy đơn'}
														{(orderDetail?.detail?.toStoreOrder?.status === 'confirm-delete-produce' ||
															orderDetail?.detail?.toStoreOrder?.status === 'confirm-delete-ship' ||
															orderDetail?.detail?.toStoreOrder?.status === 'confirm-delete-success') &&
															' đã hủy'}
														{orderDetail?.detail?.toStoreOrder?.status === 'produce' &&
															!orderDetail?.detail?.toStoreOrder?.producer.produceEnd &&
															' đang xử lý'}
														{orderDetail?.detail?.toStoreOrder?.status === 'produce' &&
															orderDetail?.detail?.toStoreOrder?.producer.produceEnd &&
															' đã xử lý'}
														{orderDetail?.detail?.toStoreOrder?.status === 'ship' &&
															!orderDetail?.detail?.toStoreOrder?.shipper.produceEnd &&
															' đang giao'}
														{orderDetail?.detail?.toStoreOrder?.status === 'success' && ' giao thành công'}
												
													</Typography>
												)}

												{orderDetail?.detail?.transferStore && (
													<Typography
														sx={{
															display: 'inline-flex',
															padding: '0 10px',
															background: mainBlue,
															color: '#fff',
															borderRadius: '10px',
															mb: 1,
															ml: 1,
														}}>
														Nhận từ {orderDetail?.detail.transferStore.fromStore.name}
													</Typography>
												)}
												{orderDetail?.detail.quickPurchase && (
													<Typography
														sx={{
															display: 'inline-flex',
															alignItems: 'center',
															padding: '0 10px',
															background: mainGreen,
															color: '#fff',
															borderRadius: '10px',
															mb: 1,
															ml: 1,
														}}>
														<ElectricBoltIcon sx={{ fontSize: '20px', marginRight: '5px' }} />
														Giao nhanh
													</Typography>
												)}
											</Box>
											<Typography sx={{ fontSize: '15px' }}>
												<b>Người tạo: </b>
												{orderDetail?.detail.creator?.user?.name}
											</Typography>
											<Typography sx={{ fontSize: '15px' }}>
												<b>Thời gian tạo: </b>
												{orderDetail?.detail.creator?.createdAt}
											</Typography>
											{orderDetail?.detail.producer?.user?.name && !orderDetail?.detail?.toStoreOrder && (
												<>
													<Divider sx={{ mb: 1, mt: 1 }} />
													<Typography sx={{ fontSize: '15px' }}>
														<b>Người xử lý: </b>
														{orderDetail?.detail.producer?.user?.name || 'chưa có'}
													</Typography>
													<Typography sx={{ fontSize: '15px' }}>
														<b>Nhận xử lý: </b>
														{orderDetail?.detail.producer?.produceStart || 'chưa có'}
													</Typography>
													<Typography sx={{ fontSize: '15px' }}>
														<b>Hoàn thành xử lý: </b>
														{orderDetail?.detail.producer?.produceEnd || 'chưa có'}
													</Typography>
												</>
											)}
											{orderDetail?.detail.shipper?.user?.name && (
												<>
													<Divider sx={{ mb: 1, mt: 1 }} />

													<Typography sx={{ fontSize: '15px' }}>
														<b>Người giao hàng: </b>
														{orderDetail?.detail.shipper?.user?.name || 'chưa có'}
													</Typography>
													<Typography sx={{ fontSize: '15px' }}>
														<b>Nhận giao hàng: </b>
														{orderDetail?.detail.shipper?.shipStart || 'chưa có'}
													</Typography>
													{orderDetail?.detail.confirmShip && (
														<Typography sx={{ fontSize: '15px' }}>
															<b>Người xác nhận giao hàng: </b>
															{orderDetail?.detail.confirmShip?.user?.name}
														</Typography>
													)}
													<Typography sx={{ fontSize: '15px' }}>
														<b>Hoàn thành giao hàng: </b>
														{orderDetail?.detail.shipper?.shipEnd || 'chưa có'}
													</Typography>
												</>
											)}
											{orderDetail?.detail?.toStoreOrder?.producer?.user?.name && (
												<>
													<Divider sx={{ mb: 1, mt: 1 }} />
													<Typography sx={{ fontSize: '15px' }}>
														<b>Người xử lý: </b>
														{orderDetail?.detail?.toStoreOrder?.producer?.user?.name || 'chưa có'}
													</Typography>
													<Typography sx={{ fontSize: '15px' }}>
														<b>Nhận xử lý: </b>
														{orderDetail?.detail?.toStoreOrder?.producer?.produceStart || 'chưa có'}
													</Typography>
													<Typography sx={{ fontSize: '15px' }}>
														<b>Hoàn thành xử lý: </b>
														{orderDetail?.detail?.toStoreOrder?.producer?.produceEnd || 'chưa có'}
													</Typography>
												</>
											)}
											{orderDetail?.detail?.toStoreOrder?.shipper?.user?.name && (
												<>
													<Divider sx={{ mb: 1, mt: 1 }} />
													<Typography sx={{ fontSize: '15px' }}>
														<b>Người giao hàng: </b>
														{orderDetail?.detail?.toStoreOrder?.shipper?.user?.name || 'chưa có'}
													</Typography>
													<Typography sx={{ fontSize: '15px' }}>
														<b>Nhận giao hàng: </b>
														{orderDetail?.detail?.toStoreOrder?.shipper?.shipStart || 'chưa có'}
													</Typography>
													{orderDetail?.detail?.toStoreOrder?.confirmShip && (
														<Typography sx={{ fontSize: '15px' }}>
															<b>Người xác nhận giao hàng: </b>
															{orderDetail?.detail?.toStoreOrder?.confirmShip?.user?.name}
														</Typography>
													)}
													<Typography sx={{ fontSize: '15px' }}>
														<b>Hoàn thành giao hàng: </b>
														{orderDetail?.detail?.toStoreOrder?.shipper?.shipEnd || 'chưa có'}
													</Typography>
												</>
											)}
										</Box>
									</Box>
								</Box>
							</Backdrop>
							<Backdrop
								sx={{
									color: '#fff',
									zIndex: 999,
									left: mediaMd ? 300 : 0,
								}}
								open={showBackdrop}
								onClick={() => {
									setShowBackdrop(false)
								}}>
								<Box>
									<Box
										sx={{
											background: '#fff',
											color: '#000',
											maxHeight: '400px',
											overflow: 'auto',
											borderRadius: '5px',
										}}>
										<Card
											sx={{
												marginBottom: '10px',
												padding: '10px',
												textAlign: 'left',
											}}>
											<Box display='flex' alignItems='center'>
												<Typography
													sx={{
														display: 'inline-flex',
														padding: '0 10px',
														background:
															orderDetail?.detail.status === 'transfer'
																? mainPurple
																: orderDetail?.detail.status === 'pending-delete-produce' ||
																	  orderDetail?.detail.status === 'pending-delete-ship' ||
																	  orderDetail?.detail.status === 'pending-delete-success' ||
																	  orderDetail?.detail.status === 'confirm-delete-produce' ||
																	  orderDetail?.detail.status === 'confirm-delete-ship' ||
																	  orderDetail?.detail.status === 'confirm-delete-success'
																	? mainRed
																	: mainGreen,
														color: '#fff',
														borderRadius: '10px',
														mb: 1,
													}}>
													{' '}
													{orderDetail?.detail.shiftCode}
													{orderDetail?.detail.shiftIndex} -
													{orderDetail?.detail.status === 'transfer' &&
														` chuyển đến ${orderDetail?.detail.toStore?.name}`}
													{orderDetail?.detail.status === 'create' && ' chờ xử lý'}
													{orderDetail?.detail.status === 'pending-produce' && ' chờ xác nhận xử lý'}
													{(orderDetail?.detail.status === 'pending-delete-produce' ||
														orderDetail?.detail.status === 'pending-delete-ship' ||
														orderDetail?.detail.status === 'pending-delete-success') &&
														' chờ hủy đơn'}
													{(orderDetail?.detail.status === 'confirm-delete-produce' ||
														orderDetail?.detail.status === 'confirm-delete-ship' ||
														orderDetail?.detail.status === 'confirm-delete-success') &&
														' đã hủy'}
													{orderDetail?.detail.status === 'produce' &&
														!orderDetail?.detail.producer.produceEnd &&
														' đang xử lý'}
													{orderDetail?.detail.status === 'produce' &&
														orderDetail?.detail.producer.produceEnd &&
														' đã xử lý'}
													{orderDetail?.detail.status === 'ship' &&
														!orderDetail?.detail.shipper.produceEnd &&
														' đang giao'}
													{orderDetail?.detail.status === 'success' && ' giao thành công'}
													
												</Typography>
												{orderDetail?.detail?.transferStore && (
													<Typography
														sx={{
															display: 'inline-flex',
															padding: '0 10px',
															background: mainBlue,
															color: '#fff',
															borderRadius: '10px',
															mb: 1,
															ml: 1,
														}}>
														Nhận từ {orderDetail?.detail.transferStore.fromStore.name}
													</Typography>
												)}
												{orderDetail?.detail.quickPurchase && (
													<Typography
														sx={{
															display: 'inline-flex',
															alignItems: 'center',
															padding: '0 10px',
															background: mainGreen,
															color: '#fff',
															borderRadius: '10px',
															mb: 1,
															ml: 1,
														}}>
														<ElectricBoltIcon sx={{ fontSize: '20px', marginRight: '5px' }} />
														Giao nhanh
													</Typography>
												)}
											</Box>
											<Typography sx={{ fontSize: '15px' }}>
												<b>Người tạo: </b>
												{orderDetail?.detail.creator?.user?.name}
											</Typography>
											<Typography sx={{ fontSize: '15px' }}>
												<b>Thời gian tạo: </b>
												{orderDetail?.detail.creator?.createdAt}
											</Typography>
											{orderDetail?.detail.producer?.user?.name && (
												<>
													<Divider sx={{ mb: 1, mt: 1 }} />
													<Typography sx={{ fontSize: '15px' }}>
														<b>Người xử lý: </b>
														{orderDetail?.detail.producer?.user?.name || 'chưa có'}
													</Typography>
													<Typography sx={{ fontSize: '15px' }}>
														<b>Nhận xử lý: </b>
														{orderDetail?.detail.producer?.produceStart || 'chưa có'}
													</Typography>
													<Typography sx={{ fontSize: '15px' }}>
														<b>Hoàn thành xử lý: </b>
														{orderDetail?.detail.producer?.produceEnd || 'chưa có'}
													</Typography>
												</>
											)}
											{orderDetail?.detail.shipper?.user?.name && (
												<>
													<Divider sx={{ mb: 1, mt: 1 }} />

													<Typography sx={{ fontSize: '15px' }}>
														<b>Người giao hàng: </b>
														{orderDetail?.detail.shipper?.user?.name || 'chưa có'}
													</Typography>
													<Typography sx={{ fontSize: '15px' }}>
														<b>Nhận giao hàng: </b>
														{orderDetail?.detail.shipper?.shipStart || 'chưa có'}
													</Typography>
													{orderDetail?.detail.confirmShip && (
														<Typography sx={{ fontSize: '15px' }}>
															<b>Người xác nhận giao hàng: </b>
															{orderDetail?.detail.confirmShip?.user?.name}
														</Typography>
													)}
													<Typography sx={{ fontSize: '15px' }}>
														<b>Hoàn thành giao hàng: </b>
														{orderDetail?.detail.shipper?.shipEnd || 'chưa có'}
													</Typography>
												</>
											)}
										</Card>
										{updateHistory?.map((order, index) => {
											return (
												<Card
													sx={{
														padding: '10px 20px',
														background: '#fff',
														mt: 1,
														textAlign: 'left',
													}}
													key={index}
													onClick={(e) => {
														e.stopPropagation()
													}}>
													{index === 0 && (
														<Typography
															sx={{
																display: 'inline-flex',
																alignItems: 'flex-start',
																color: '#fff',
																background: mainGreen,
																padding: '2px 10px',
																borderRadius: '10px',
																mb: 1,
															}}>
															<EditIcon sx={{ fontSize: '20px', marginRight: '5px' }} /> Nhập đơn
														</Typography>
													)}
													{index > 0 && (
														<Typography
															sx={{
																display: 'inline-flex',
																alignItems: 'flex-start',
																color: '#fff',
																background: mainGreen,
																padding: '2px 10px',
																borderRadius: '10px',
																mb: 1,
															}}>
															<EditIcon sx={{ fontSize: '20px', marginRight: '5px' }} /> Chỉnh sửa lần {index}
														</Typography>
													)}
													{index > 0 && (
														<>
															<Typography>
																<b>Người chỉnh sửa: </b>
																{order.editor?.name}
															</Typography>
															<Typography>
																<b>Thời gian chỉnh sửa: </b>
																{order.timeStamp}
															</Typography>
															<Divider sx={{ mb: 1, mt: 1 }} />
														</>
													)}

													<Typography>
														<b>Khối lượng: </b>
														{order.orderData.quantity}kg
													</Typography>
													<Typography>
														<b>Tiền: </b>
														{order.orderData.totalPrice?.toLocaleString()}đ{' '}
														{order.orderData.payment === 'transfer' && (
															<span style={{ color: mainGreen }}>
																<b>(Chuyển khoản)</b>
															</span>
														)}
													</Typography>
													<Typography>
														<b>Thông tin: </b>
														{order.orderData.detail && (
															<span
																dangerouslySetInnerHTML={{
																	__html: transformDetailWithPhone(order.orderData.detail),
																}}></span>
														)}
													</Typography>
													{order.orderData.tag?.map((tag, index) => {
														return (
															<Typography
																sx={{
																	display: 'inline-block',
																	fontSize: '12px',
																	padding: '2px 10px',
																	borderRadius: '10px',
																	color: '#fff',
																	background: `${tag.color}`,
																	mr: 1,
																}}
																key={index}>
																{tag?.name}
															</Typography>
														)
													})}
													<Box>
														{order.orderData.photoAttach.map((photo, index) => {
															return (
																<Fragment key={index}>
																	<img
																		loading='lazy'
																		src={photo}
																		onClick={(e) => {
																			e.stopPropagation()
																			openImageViewer(photo)
																		}}
																		width='30'
																		height='30'
																		style={{
																			marginRight: '8px',
																			marginTop: '5px',
																			cursor: 'pointer',
																		}}
																		alt=''
																	/>
																</Fragment>
															)
														})}
													</Box>
												</Card>
											)
										})}
									</Box>
								</Box>
							</Backdrop>
							{statistics?.detail.length > 0 &&
								orderFilter === '' &&
								statistics?.detail.map((order, index) => {
									return (
										<Card
											key={index}
											sx={{
												marginBottom: '10px',
												padding: '10px',
												textAlign: 'left',
											}}>
											<Box display='flex' alignItems='center'>
												<Typography
													sx={{
														display: 'inline-flex',
														padding: '0 10px',
														background:
															order.detail.status === 'transfer'
																? mainPurple
																: order.detail.status === 'pending-delete-produce' ||
																	  order.detail.status === 'pending-delete-ship' ||
																	  order.detail.status === 'pending-delete-success' ||
																	  order.detail.status === 'confirm-delete-produce' ||
																	  order.detail.status === 'confirm-delete-ship' ||
																	  order.detail.status === 'confirm-delete-success'
																	? mainRed
																	: mainGreen,
														color: '#fff',
														borderRadius: '10px',
														mb: 1,
													}}>
													{' '}
													{order.detail.shiftCode}
													{order.detail.shiftIndex} -
													{order.detail.status === 'transfer' && ` chuyển đến ${order.detail.toStore?.name}`}
													{order.detail.status === 'create' && ' chờ xử lý'}
													{order.detail.status === 'pending-produce' && ' chờ xác nhận xử lý'}
													{(order.detail.status === 'pending-delete-produce' ||
														order.detail.status === 'pending-delete-ship' ||
														order.detail.status === 'pending-delete-success') &&
														' chờ hủy đơn'}
													{(order.detail.status === 'confirm-delete-produce' ||
														order.detail.status === 'confirm-delete-ship' ||
														order.detail.status === 'confirm-delete-success') &&
														' Đã hủy'}
													{order.detail.status === 'produce' && !order.detail.producer.produceEnd && ' đang xử lý'}
													{order.detail.status === 'produce' && order.detail.producer.produceEnd && ' đã xử lý'}
													{order.detail.status === 'ship' && !order.detail.shipper.produceEnd && ' đang giao'}
													{order.detail.status === 'success' && ' giao thành công'}
								
												</Typography>
									
												{order.detail?.transferStore && (
													<Typography
														sx={{
															display: 'inline-flex',
															padding: '0 10px',
															background: mainBlue,
															color: '#fff',
															borderRadius: '10px',
															mb: 1,
															ml: 1,
														}}>
														Nhận từ {order.detail.transferStore.fromStore.name}
													</Typography>
												)}
												{order.detail.quickPurchase && (
													<Typography
														sx={{
															display: 'inline-flex',
															alignItems: 'center',
															padding: '0 10px',
															background: mainGreen,
															color: '#fff',
															borderRadius: '10px',
															mb: 1,
															ml: 1,
														}}>
														<ElectricBoltIcon sx={{ fontSize: '20px', marginRight: '5px' }} />
														Giao nhanh
													</Typography>
												)}
												{!order.detail.edited?.value && (
													<Typography
														sx={{
															display: 'inline-flex',
															mb: 1,
															ml: 1,
															textDecoration: 'underline',
															color: '#1939B7',
															cursor: 'pointer',
															fontStyle: 'italic',
														}}
														onClick={() => {
															setOrderDetail(order)
															setShowDetailBackdrop(true)
														}}>
														Chi tiết
													</Typography>
												)}
												{order.detail.edited?.value && (
													<Typography
														sx={{
															display: 'inline-flex',
															mb: 1,
															ml: 1,
															textDecoration: 'underline',
															color: '#1939B7',
															cursor: 'pointer',
															fontStyle: 'italic',
														}}
														onClick={() => {
															setUpdateHistory(order.updatedOrderDetail)
															setOrderDetail(order)
															setShowBackdrop(true)
														}}>
														Lịch sử chỉnh sửa
													</Typography>
												)}
											</Box>

											<Box sx={{ p: 0 }}>
												<Typography sx={{ fontSize: '15px' }}>
													<b>Khối lượng: </b>
													{order.detail.quantity}kg - <b>Tiền: </b>
													{order.detail.totalPrice.toLocaleString()}đ{' '}
													{order.detail.payment === 'transfer' && (
														<span style={{ color: mainGreen, fontWeight: 'bold' }}>(Chuyển khoản)</span>
													)}{' '}
													{order.detail.app && <span style={{ color: mainRed, fontWeight: 'bold' }}>(App)</span>}
												</Typography>
												<Typography sx={{ fontSize: '15px' }}>
													<b>Thông tin: </b>
													{order.detail.detail && (
														<span
															dangerouslySetInnerHTML={{
																__html: transformDetailWithPhone(order.detail.detail),
															}}></span>
													)}
												</Typography>
												{order.detail.tag?.map((tag, index) => {
													return (
														<Typography
															sx={{
																display: 'inline-block',
																fontSize: '12px',
																padding: '2px 10px',
																borderRadius: '10px',
																color: '#fff',
																background: `${tag.color}`,
																mr: 1,
															}}
															key={index}>
															{tag?.name}
														</Typography>
													)
												})}
												<Box>
													{order.detail.photoAttach.map((photo, index) => {
														return (
															<Fragment key={index}>
																<img
																	loading='lazy'
																	src={photo}
																	onClick={(e) => {
																		e.stopPropagation()
																		openImageViewer(photo)
																	}}
																	width='30'
																	height='30'
																	style={{
																		marginRight: '8px',
																		marginTop: '5px',
																		cursor: 'pointer',
																	}}
																	alt=''
																/>
															</Fragment>
														)
													})}
												</Box>
											</Box>
										</Card>
									)
								})}
							{statistics?.detail.length > 0 &&
								orderFilter === 'transfer' &&
								statistics?.detail
									?.filter((order) => order.detail.payment === 'transfer')
									.map((order, index) => {
										return (
											<Card
												key={index}
												sx={{
													marginBottom: '10px',
													padding: '10px',
													textAlign: 'left',
												}}>
												<Box display='flex' alignItems='center'>
													<Typography
														sx={{
															display: 'inline-flex',
															padding: '0 10px',
															background:
																order.detail.status === 'transfer'
																	? mainPurple
																	: order.detail.status === 'pending-delete-produce' ||
																		  order.detail.status === 'pending-delete-ship' ||
																		  order.detail.status === 'pending-delete-success' ||
																		  order.detail.status === 'confirm-delete-produce' ||
																		  order.detail.status === 'confirm-delete-ship' ||
																		  order.detail.status === 'confirm-delete-success'
																		? mainRed
																		: mainGreen,
															color: '#fff',
															borderRadius: '10px',
															mb: 1,
														}}>
														{' '}
														{order.detail.shiftCode}
														{order.detail.shiftIndex} -
														{order.detail.status === 'transfer' && ` chuyển đến ${order.detail.toStore?.name}`}
														{order.detail.status === 'create' && ' chờ xử lý'}
														{order.detail.status === 'produce' && !order.detail.producer.produceEnd && ' đang xử lý'}
														{order.detail.status === 'produce' && order.detail.producer.produceEnd && ' đã xử lý'}
														{order.detail.status === 'ship' && !order.detail.shipper.produceEnd && ' đang giao'}
														{order.detail.status === 'success' && ' giao thành công'}
	
													</Typography>
													{order.detail?.transferStore && (
														<Typography
															sx={{
																display: 'inline-flex',
																padding: '0 10px',
																background: mainBlue,
																color: '#fff',
																borderRadius: '10px',
																mb: 1,
																ml: 1,
															}}>
															Nhận từ {order.detail.transferStore.fromStore.name}
														</Typography>
													)}
													{order.detail.quickPurchase && (
														<Typography
															sx={{
																display: 'inline-flex',
																alignItems: 'center',
																padding: '0 10px',
																background: mainGreen,
																color: '#fff',
																borderRadius: '10px',
																mb: 1,
																ml: 1,
															}}>
															<ElectricBoltIcon sx={{ fontSize: '20px', marginRight: '5px' }} />
															Giao nhanh
														</Typography>
													)}
													{!order.detail.edited?.value && (
														<Typography
															sx={{
																display: 'inline-flex',
																mb: 1,
																ml: 1,
																textDecoration: 'underline',
																color: '#1939B7',
																cursor: 'pointer',
																fontStyle: 'italic',
															}}
															onClick={() => {
																setOrderDetail(order)
																setShowDetailBackdrop(true)
															}}>
															Chi tiết
														</Typography>
													)}
													{order.detail.edited?.value && (
														<Typography
															sx={{
																display: 'inline-flex',
																mb: 1,
																ml: 1,
																textDecoration: 'underline',
																color: '#1939B7',
																cursor: 'pointer',
																fontStyle: 'italic',
															}}
															onClick={() => {
																setUpdateHistory(order.updatedOrderDetail)
																setOrderDetail(order)
																setShowBackdrop(true)
															}}>
															Lịch sử chỉnh sửa
														</Typography>
													)}
												</Box>

												<Box sx={{ p: 0 }}>
													<Typography sx={{ fontSize: '15px' }}>
														<b>Khối lượng: </b>
														{order.detail.quantity}kg - <b>Tiền: </b>
														{order.detail.totalPrice.toLocaleString()}đ{' '}
														{order.detail.payment === 'transfer' && (
															<span style={{ color: mainGreen, fontWeight: 'bold' }}>(Chuyển khoản)</span>
														)}{' '}
														{order.detail.app && <span style={{ color: mainRed, fontWeight: 'bold' }}>(App)</span>}
													</Typography>
													<Typography sx={{ fontSize: '15px' }}>
														<b>Thông tin: </b>
														{order.detail.detail && (
															<span
																dangerouslySetInnerHTML={{
																	__html: transformDetailWithPhone(order.detail.detail),
																}}></span>
														)}
													</Typography>
													{order.detail.tag?.map((tag, index) => {
														return (
															<Typography
																sx={{
																	display: 'inline-block',
																	fontSize: '12px',
																	padding: '2px 10px',
																	borderRadius: '10px',
																	color: '#fff',
																	background: `${tag.color}`,
																	mr: 1,
																}}
																key={index}>
																{tag?.name}
															</Typography>
														)
													})}
													<Box>
														{order.detail.photoAttach.map((photo, index) => {
															return (
																<Fragment key={index}>
																	<img
																		loading='lazy'
																		src={photo}
																		onClick={(e) => {
																			e.stopPropagation()
																			openImageViewer(photo)
																		}}
																		width='30'
																		height='30'
																		style={{
																			marginRight: '8px',
																			marginTop: '5px',
																			cursor: 'pointer',
																		}}
																		alt=''
																	/>
																</Fragment>
															)
														})}
													</Box>
												</Box>
											</Card>
										)
									})}
							{statistics?.detail.length > 0 &&
								orderFilter === 'quickPurchase' &&
								statistics?.detail
									?.filter((order) => order.detail.quickPurchase === true)
									.map((order, index) => {
										return (
											<Card
												key={index}
												sx={{
													marginBottom: '10px',
													padding: '10px',
													textAlign: 'left',
												}}>
												<Box display='flex' alignItems='center'>
													<Typography
														sx={{
															display: 'inline-flex',
															padding: '0 10px',
															background:
																order.detail.status === 'transfer'
																	? mainPurple
																	: order.detail.status === 'pending-delete-produce' ||
																		  order.detail.status === 'pending-delete-ship' ||
																		  order.detail.status === 'pending-delete-success' ||
																		  order.detail.status === 'confirm-delete-produce' ||
																		  order.detail.status === 'confirm-delete-ship' ||
																		  order.detail.status === 'confirm-delete-success'
																		? mainRed
																		: mainGreen,
															color: '#fff',
															borderRadius: '10px',
															mb: 1,
														}}>
														{' '}
														{order.detail.shiftCode}
														{order.detail.shiftIndex} -
														{order.detail.status === 'transfer' && ` chuyển đến ${order.detail.toStore?.name}`}
														{order.detail.status === 'create' && ' chờ xử lý'}
														{order.detail.status === 'produce' && !order.detail.producer.produceEnd && ' đang xử lý'}
														{order.detail.status === 'produce' && order.detail.producer.produceEnd && ' đã xử lý'}
														{order.detail.status === 'ship' && !order.detail.shipper.produceEnd && ' đang giao'}
														{order.detail.status === 'success' && ' giao thành công'}
													</Typography>
													{order.detail?.transferStore && (
														<Typography
															sx={{
																display: 'inline-flex',
																padding: '0 10px',
																background: mainBlue,
																color: '#fff',
																borderRadius: '10px',
																mb: 1,
																ml: 1,
															}}>
															Nhận từ {order.detail.transferStore.fromStore.name}
														</Typography>
													)}
													{order.detail.quickPurchase && (
														<Typography
															sx={{
																display: 'inline-flex',
																alignItems: 'center',
																padding: '0 10px',
																background: mainGreen,
																color: '#fff',
																borderRadius: '10px',
																mb: 1,
																ml: 1,
															}}>
															<ElectricBoltIcon sx={{ fontSize: '20px', marginRight: '5px' }} />
															Giao nhanh
														</Typography>
													)}
													{!order.detail.edited?.value && (
														<Typography
															sx={{
																display: 'inline-flex',
																mb: 1,
																ml: 1,
																textDecoration: 'underline',
																color: '#1939B7',
																cursor: 'pointer',
																fontStyle: 'italic',
															}}
															onClick={() => {
																setOrderDetail(order)
																setShowDetailBackdrop(true)
															}}>
															Chi tiết
														</Typography>
													)}
													{order.detail.edited?.value && (
														<Typography
															sx={{
																display: 'inline-flex',
																mb: 1,
																ml: 1,
																textDecoration: 'underline',
																color: '#1939B7',
																cursor: 'pointer',
																fontStyle: 'italic',
															}}
															onClick={() => {
																setUpdateHistory(order.updatedOrderDetail)
																setOrderDetail(order)
																setShowBackdrop(true)
															}}>
															Lịch sử chỉnh sửa
														</Typography>
													)}
												</Box>

												<Box sx={{ p: 0 }}>
													<Typography sx={{ fontSize: '15px' }}>
														<b>Khối lượng: </b>
														{order.detail.quantity}kg - <b>Tiền: </b>
														{order.detail.totalPrice.toLocaleString()}đ{' '}
														{order.detail.payment === 'transfer' && (
															<span style={{ color: mainGreen, fontWeight: 'bold' }}>(Chuyển khoản)</span>
														)}{' '}
														{order.detail.app && <span style={{ color: mainRed, fontWeight: 'bold' }}>(App)</span>}
													</Typography>
													<Typography sx={{ fontSize: '15px' }}>
														<b>Thông tin: </b>
														{order.detail.detail && (
															<span
																dangerouslySetInnerHTML={{
																	__html: transformDetailWithPhone(order.detail.detail),
																}}></span>
														)}
													</Typography>
													{order.detail.tag?.map((tag, index) => {
														return (
															<Typography
																sx={{
																	display: 'inline-block',
																	fontSize: '12px',
																	padding: '2px 10px',
																	borderRadius: '10px',
																	color: '#fff',
																	background: `${tag.color}`,
																	mr: 1,
																}}
																key={index}>
																{tag?.name}
															</Typography>
														)
													})}
													<Box>
														{order.detail.photoAttach.map((photo, index) => {
															return (
																<Fragment key={index}>
																	<img
																		loading='lazy'
																		src={photo}
																		onClick={(e) => {
																			e.stopPropagation()
																			openImageViewer(photo)
																		}}
																		width='30'
																		height='30'
																		style={{
																			marginRight: '8px',
																			marginTop: '5px',
																			cursor: 'pointer',
																		}}
																		alt=''
																	/>
																</Fragment>
															)
														})}
													</Box>
												</Box>
											</Card>
										)
									})}
							{statistics?.detail.length > 0 &&
								orderFilter === 'normal' &&
								statistics?.detail
									?.filter((order) => order.detail.payment === 'cash' && !order.detail.app)
									.map((order, index) => {
										return (
											<Card
												key={index}
												sx={{
													marginBottom: '10px',
													padding: '10px',
													textAlign: 'left',
												}}>
												<Box display='flex' alignItems='center'>
													<Typography
														sx={{
															display: 'inline-flex',
															padding: '0 10px',
															background:
																order.detail.status === 'transfer'
																	? mainPurple
																	: order.detail.status === 'pending-delete-produce' ||
																		  order.detail.status === 'pending-delete-ship' ||
																		  order.detail.status === 'pending-delete-success' ||
																		  order.detail.status === 'confirm-delete-produce' ||
																		  order.detail.status === 'confirm-delete-ship' ||
																		  order.detail.status === 'confirm-delete-success'
																		? mainRed
																		: mainGreen,
															color: '#fff',
															borderRadius: '10px',
															mb: 1,
														}}>
														{' '}
														{order.detail.shiftCode}
														{order.detail.shiftIndex} -
														{order.detail.status === 'transfer' && ` chuyển đến ${order.detail.toStore?.name}`}
														{order.detail.status === 'create' && ' chờ xử lý'}
														{order.detail.status === 'produce' && !order.detail.producer.produceEnd && ' đang xử lý'}
														{order.detail.status === 'produce' && order.detail.producer.produceEnd && ' đã xử lý'}
														{order.detail.status === 'ship' && !order.detail.shipper.produceEnd && ' đang giao'}
														{order.detail.status === 'success' && ' giao thành công'}
													</Typography>
													{order.detail?.transferStore && (
														<Typography
															sx={{
																display: 'inline-flex',
																padding: '0 10px',
																background: mainBlue,
																color: '#fff',
																borderRadius: '10px',
																mb: 1,
																ml: 1,
															}}>
															Nhận từ {order.detail.transferStore.fromStore.name}
														</Typography>
													)}
													{order.detail.quickPurchase && (
														<Typography
															sx={{
																display: 'inline-flex',
																alignItems: 'center',
																padding: '0 10px',
																background: mainGreen,
																color: '#fff',
																borderRadius: '10px',
																mb: 1,
																ml: 1,
															}}>
															<ElectricBoltIcon sx={{ fontSize: '20px', marginRight: '5px' }} />
															Giao nhanh
														</Typography>
													)}
													{!order.detail.edited?.value && (
														<Typography
															sx={{
																display: 'inline-flex',
																mb: 1,
																ml: 1,
																textDecoration: 'underline',
																color: '#1939B7',
																cursor: 'pointer',
																fontStyle: 'italic',
															}}
															onClick={() => {
																setOrderDetail(order)
																setShowDetailBackdrop(true)
															}}>
															Chi tiết
														</Typography>
													)}
													{order.detail.edited?.value && (
														<Typography
															sx={{
																display: 'inline-flex',
																mb: 1,
																ml: 1,
																textDecoration: 'underline',
																color: '#1939B7',
																cursor: 'pointer',
																fontStyle: 'italic',
															}}
															onClick={() => {
																setUpdateHistory(order.updatedOrderDetail)
																setOrderDetail(order)
																setShowBackdrop(true)
															}}>
															Lịch sử chỉnh sửa
														</Typography>
													)}
												</Box>

												<Box sx={{ p: 0 }}>
													<Typography sx={{ fontSize: '15px' }}>
														<b>Khối lượng: </b>
														{order.detail.quantity}kg - <b>Tiền: </b>
														{order.detail.totalPrice.toLocaleString()}đ{' '}
													</Typography>
													<Typography sx={{ fontSize: '15px' }}>
														<b>Thông tin: </b>
														{order.detail.detail && (
															<span
																dangerouslySetInnerHTML={{
																	__html: transformDetailWithPhone(order.detail.detail),
																}}></span>
														)}
													</Typography>
													{order.detail.tag?.map((tag, index) => {
														return (
															<Typography
																sx={{
																	display: 'inline-block',
																	fontSize: '12px',
																	padding: '2px 10px',
																	borderRadius: '10px',
																	color: '#fff',
																	background: `${tag.color}`,
																	mr: 1,
																}}
																key={index}>
																{tag?.name}
															</Typography>
														)
													})}
													<Box>
														{order.detail.photoAttach.map((photo, index) => {
															return (
																<Fragment key={index}>
																	<img
																		loading='lazy'
																		src={photo}
																		onClick={(e) => {
																			e.stopPropagation()
																			openImageViewer(photo)
																		}}
																		width='30'
																		height='30'
																		style={{
																			marginRight: '8px',
																			marginTop: '5px',
																			cursor: 'pointer',
																		}}
																		alt=''
																	/>
																</Fragment>
															)
														})}
													</Box>
												</Box>
											</Card>
										)
									})}
							{statistics?.detail.length > 0 &&
								orderFilter === 'app' &&
								statistics?.detail
									?.filter((order) => order.detail.app === true && order.detail.payment === 'cash')
									.map((order, index) => {
										return (
											<Card
												key={index}
												sx={{
													marginBottom: '10px',
													padding: '10px',
													textAlign: 'left',
												}}>
												<Box display='flex' alignItems='center'>
													<Typography
														sx={{
															display: 'inline-flex',
															padding: '0 10px',
															background:
																order.detail.status === 'transfer'
																	? mainPurple
																	: order.detail.status === 'pending-delete-produce' ||
																		  order.detail.status === 'pending-delete-ship' ||
																		  order.detail.status === 'pending-delete-success' ||
																		  order.detail.status === 'confirm-delete-produce' ||
																		  order.detail.status === 'confirm-delete-ship' ||
																		  order.detail.status === 'confirm-delete-success'
																		? mainRed
																		: mainGreen,
															color: '#fff',
															borderRadius: '10px',
															mb: 1,
														}}>
														{' '}
														{order.detail.shiftCode}
														{order.detail.shiftIndex} -
														{order.detail.status === 'transfer' && ` chuyển đến ${order.detail.toStore?.name}`}
														{order.detail.status === 'create' && ' chờ xử lý'}
														{order.detail.status === 'produce' && !order.detail.producer.produceEnd && ' đang xử lý'}
														{order.detail.status === 'produce' && order.detail.producer.produceEnd && ' đã xử lý'}
														{order.detail.status === 'ship' && !order.detail.shipper.produceEnd && ' đang giao'}
														{order.detail.status === 'success' && ' giao thành công'}
													</Typography>
													{order.detail?.transferStore && (
														<Typography
															sx={{
																display: 'inline-flex',
																padding: '0 10px',
																background: mainBlue,
																color: '#fff',
																borderRadius: '10px',
																mb: 1,
																ml: 1,
															}}>
															Nhận từ {order.detail.transferStore.fromStore.name}
														</Typography>
													)}
													{order.detail.quickPurchase && (
														<Typography
															sx={{
																display: 'inline-flex',
																alignItems: 'center',
																padding: '0 10px',
																background: mainGreen,
																color: '#fff',
																borderRadius: '10px',
																mb: 1,
																ml: 1,
															}}>
															<ElectricBoltIcon sx={{ fontSize: '20px', marginRight: '5px' }} />
															Giao nhanh
														</Typography>
													)}
													{!order.detail.edited?.value && (
														<Typography
															sx={{
																display: 'inline-flex',
																mb: 1,
																ml: 1,
																textDecoration: 'underline',
																color: '#1939B7',
																cursor: 'pointer',
																fontStyle: 'italic',
															}}
															onClick={() => {
																setOrderDetail(order)
																setShowDetailBackdrop(true)
															}}>
															Chi tiết
														</Typography>
													)}
													{order.detail.edited?.value && (
														<Typography
															sx={{
																display: 'inline-flex',
																mb: 1,
																ml: 1,
																textDecoration: 'underline',
																color: '#1939B7',
																cursor: 'pointer',
																fontStyle: 'italic',
															}}
															onClick={() => {
																setUpdateHistory(order.updatedOrderDetail)
																setOrderDetail(order)
																setShowBackdrop(true)
															}}>
															Lịch sử chỉnh sửa
														</Typography>
													)}
												</Box>

												<Box sx={{ p: 0 }}>
													<Typography sx={{ fontSize: '15px' }}>
														<b>Khối lượng: </b>
														{order.detail.quantity}kg - <b>Tiền: </b>
														{order.detail.totalPrice.toLocaleString()}đ{' '}
														{order.detail.payment === 'transfer' && (
															<span style={{ color: mainGreen, fontWeight: 'bold' }}>(Chuyển khoản)</span>
														)}{' '}
														{order.detail.app && <span style={{ color: mainRed, fontWeight: 'bold' }}>(App)</span>}
													</Typography>
													<Typography sx={{ fontSize: '15px' }}>
														<b>Thông tin: </b>
														{order.detail.detail && (
															<span
																dangerouslySetInnerHTML={{
																	__html: transformDetailWithPhone(order.detail.detail),
																}}></span>
														)}
													</Typography>
													{order.detail.tag?.map((tag, index) => {
														return (
															<Typography
																sx={{
																	display: 'inline-block',
																	fontSize: '12px',
																	padding: '2px 10px',
																	borderRadius: '10px',
																	color: '#fff',
																	background: `${tag.color}`,
																	mr: 1,
																}}
																key={index}>
																{tag?.name}
															</Typography>
														)
													})}
													<Box>
														{order.detail.photoAttach.map((photo, index) => {
															return (
																<Fragment key={index}>
																	<img
																		loading='lazy'
																		src={photo}
																		onClick={(e) => {
																			e.stopPropagation()
																			openImageViewer(photo)
																		}}
																		width='30'
																		height='30'
																		style={{
																			marginRight: '8px',
																			marginTop: '5px',
																			cursor: 'pointer',
																		}}
																		alt=''
																	/>
																</Fragment>
															)
														})}
													</Box>
												</Box>
											</Card>
										)
									})}
							{statistics?.detail.length > 0 &&
								orderFilter === 'cancel' &&
								statistics?.detail
									?.filter(
										(order) =>
											order.detail.status === 'confirm-delete-produce' ||
											order.detail.status === 'confirm-delete-ship' ||
											order.detail.status === 'confirm-delete-success',
									)
									.map((order, index) => {
										return (
											<Card
												key={index}
												sx={{
													marginBottom: '10px',
													padding: '10px',
													textAlign: 'left',
												}}>
												<Box display='flex' alignItems='center'>
													<Typography
														sx={{
															display: 'inline-flex',
															padding: '0 10px',
															background: mainRed,
															color: '#fff',
															borderRadius: '10px',
															mb: 1,
														}}>
														{' '}
														{order.detail.shiftCode}
														{order.detail.shiftIndex} -
														{(order.detail.status === 'confirm-delete-produce' ||
															order.detail.status === 'confirm-delete-ship' ||
															order.detail.status === 'confirm-delete-success') &&
															' đã hủy'}
													</Typography>
													{order.detail?.transferStore && (
														<Typography
															sx={{
																display: 'inline-flex',
																padding: '0 10px',
																background: mainBlue,
																color: '#fff',
																borderRadius: '10px',
																mb: 1,
																ml: 1,
															}}>
															Nhận từ {order.detail.transferStore.fromStore.name}
														</Typography>
													)}
													{order.detail.quickPurchase && (
														<Typography
															sx={{
																display: 'inline-flex',
																alignItems: 'center',
																padding: '0 10px',
																background: mainGreen,
																color: '#fff',
																borderRadius: '10px',
																mb: 1,
																ml: 1,
															}}>
															<ElectricBoltIcon sx={{ fontSize: '20px', marginRight: '5px' }} />
															Giao nhanh
														</Typography>
													)}
													{!order.detail.edited?.value && (
														<Typography
															sx={{
																display: 'inline-flex',
																mb: 1,
																ml: 1,
																textDecoration: 'underline',
																color: '#1939B7',
																cursor: 'pointer',
																fontStyle: 'italic',
															}}
															onClick={() => {
																setOrderDetail(order)
																setShowDetailBackdrop(true)
															}}>
															Chi tiết
														</Typography>
													)}
													{order.detail.edited?.value && (
														<Typography
															sx={{
																display: 'inline-flex',
																mb: 1,
																ml: 1,
																textDecoration: 'underline',
																color: '#1939B7',
																cursor: 'pointer',
																fontStyle: 'italic',
															}}
															onClick={() => {
																setUpdateHistory(order.updatedOrderDetail)
																setOrderDetail(order)
																setShowBackdrop(true)
															}}>
															Lịch sử chỉnh sửa
														</Typography>
													)}
												</Box>

												<Box sx={{ p: 0 }}>
													<Typography sx={{ fontSize: '15px' }}>
														<b>Khối lượng: </b>
														{order.detail.quantity}kg - <b>Tiền: </b>
														{order.detail.totalPrice.toLocaleString()}đ{' '}
														{order.detail.payment === 'transfer' && (
															<span style={{ color: mainGreen, fontWeight: 'bold' }}>(Chuyển khoản)</span>
														)}{' '}
														{order.detail.app && <span style={{ color: mainRed, fontWeight: 'bold' }}>(App)</span>}
													</Typography>
													<Typography sx={{ fontSize: '15px' }}>
														<b>Thông tin: </b>
														{order.detail.detail && (
															<span
																dangerouslySetInnerHTML={{
																	__html: transformDetailWithPhone(order.detail.detail),
																}}></span>
														)}
													</Typography>
													{order.detail.tag?.map((tag, index) => {
														return (
															<Typography
																sx={{
																	display: 'inline-block',
																	fontSize: '12px',
																	padding: '2px 10px',
																	borderRadius: '10px',
																	color: '#fff',
																	background: `${tag.color}`,
																	mr: 1,
																}}
																key={index}>
																{tag.name}
															</Typography>
														)
													})}
													<Box>
														{order.detail.photoAttach.map((photo, index) => {
															return (
																<Fragment key={index}>
																	<img
																		loading='lazy'
																		src={photo}
																		onClick={(e) => {
																			e.stopPropagation()
																			openImageViewer(photo)
																		}}
																		width='30'
																		height='30'
																		style={{
																			marginRight: '8px',
																			marginTop: '5px',
																			cursor: 'pointer',
																		}}
																		alt=''
																	/>
																</Fragment>
															)
														})}
													</Box>
												</Box>
											</Card>
										)
									})}
							{statistics?.detail.length > 0 &&
								orderFilter === 'send' &&
								statistics?.detail
									?.filter((order) => order.detail.status === 'transfer')
									.map((order, index) => {
										return (
											<Card
												key={index}
												sx={{
													marginBottom: '10px',
													padding: '10px',
													textAlign: 'left',
												}}>
												<Box display='flex' alignItems='center'>
													<Typography
														sx={{
															display: 'inline-flex',
															padding: '0 10px',
															background: mainPurple,
															color: '#fff',
															borderRadius: '10px',
															mb: 1,
														}}>
														{' '}
														{order.detail.shiftCode}
														{order.detail.shiftIndex} -
														{order.detail.status === 'transfer' &&
															order.detail?.toStore &&
															` chuyển đến ${order.detail?.toStore?.name}`}
														{order.detail.status === 'transfer' && !order.detail?.toStore && ` đã chuyển`}
													</Typography>
													{order.detail.quickPurchase && (
														<Typography
															sx={{
																display: 'inline-flex',
																alignItems: 'center',
																padding: '0 10px',
																background: mainGreen,
																color: '#fff',
																borderRadius: '10px',
																mb: 1,
																ml: 1,
															}}>
															<ElectricBoltIcon sx={{ fontSize: '20px', marginRight: '5px' }} />
															Giao nhanh
														</Typography>
													)}
													{!order.detail.edited?.value && (
														<Typography
															sx={{
																display: 'inline-flex',
																mb: 1,
																ml: 1,
																textDecoration: 'underline',
																color: '#1939B7',
																cursor: 'pointer',
																fontStyle: 'italic',
															}}
															onClick={() => {
																setOrderDetail(order)
																setShowDetailBackdrop(true)
															}}>
															Chi tiết
														</Typography>
													)}
													{order.detail.edited?.value && (
														<Typography
															sx={{
																display: 'inline-flex',
																mb: 1,
																ml: 1,
																textDecoration: 'underline',
																color: '#1939B7',
																cursor: 'pointer',
																fontStyle: 'italic',
															}}
															onClick={() => {
																setUpdateHistory(order.updatedOrderDetail)
																setOrderDetail(order)
																setShowBackdrop(true)
															}}>
															Lịch sử chỉnh sửa
														</Typography>
													)}
												</Box>

												<Box sx={{ p: 0 }}>
													<Typography sx={{ fontSize: '15px' }}>
														<b>Khối lượng: </b>
														{order.detail.quantity}kg - <b>Tiền: </b>
														{order.detail.totalPrice.toLocaleString()}đ{' '}
														{order.detail.payment === 'transfer' && (
															<span style={{ color: mainGreen, fontWeight: 'bold' }}>(Chuyển khoản)</span>
														)}{' '}
														{order.detail.app && <span style={{ color: mainRed, fontWeight: 'bold' }}>(App)</span>}
													</Typography>
													<Typography sx={{ fontSize: '15px' }}>
														<b>Thông tin: </b>
														{order.detail.detail && (
															<span
																dangerouslySetInnerHTML={{
																	__html: transformDetailWithPhone(order.detail.detail),
																}}></span>
														)}
													</Typography>
													{order.detail.tag?.map((tag, index) => {
														return (
															<Typography
																sx={{
																	display: 'inline-block',
																	fontSize: '12px',
																	padding: '2px 10px',
																	borderRadius: '10px',
																	color: '#fff',
																	background: `${tag.color}`,
																	mr: 1,
																}}
																key={index}>
																{tag.name}
															</Typography>
														)
													})}
													<Box>
														{order.detail.photoAttach.map((photo, index) => {
															return (
																<Fragment key={index}>
																	<img
																		loading='lazy'
																		src={photo}
																		onClick={(e) => {
																			e.stopPropagation()
																			openImageViewer(photo)
																		}}
																		width='30'
																		height='30'
																		style={{
																			marginRight: '8px',
																			marginTop: '5px',
																			cursor: 'pointer',
																		}}
																		alt=''
																	/>
																</Fragment>
															)
														})}
													</Box>
												</Box>
											</Card>
										)
									})}

							{statistics?.detail.length > 0 &&
								orderFilter === 'receive' &&
								statistics?.detail
									?.filter((order) => order.detail.transferStore)
									.map((order, index) => {
										return (
											<Card
												key={index}
												sx={{
													marginBottom: '10px',
													padding: '10px',
													textAlign: 'left',
												}}>
												<Box display='flex' alignItems='center'>
													<Typography
														sx={{
															display: 'inline-flex',
															padding: '0 10px',
															background: mainBlue,
															color: '#fff',
															borderRadius: '10px',
															mb: 1,
														}}>
														{' '}
														{order.detail.shiftCode}
														{order.detail.shiftIndex} - nhận từ {order.detail.transferStore.fromStore.name}
													</Typography>
													{order.detail.quickPurchase && (
														<Typography
															sx={{
																display: 'inline-flex',
																alignItems: 'center',
																padding: '0 10px',
																background: mainGreen,
																color: '#fff',
																borderRadius: '10px',
																mb: 1,
																ml: 1,
															}}>
															<ElectricBoltIcon sx={{ fontSize: '20px', marginRight: '5px' }} />
															Giao nhanh
														</Typography>
													)}
													{!order.detail.edited?.value && (
														<Typography
															sx={{
																display: 'inline-flex',
																mb: 1,
																ml: 1,
																textDecoration: 'underline',
																color: '#1939B7',
																cursor: 'pointer',
																fontStyle: 'italic',
															}}
															onClick={() => {
																setOrderDetail(order)
																setShowDetailBackdrop(true)
															}}>
															Chi tiết
														</Typography>
													)}
													{order.detail.edited?.value && (
														<Typography
															sx={{
																display: 'inline-flex',
																mb: 1,
																ml: 1,
																textDecoration: 'underline',
																color: '#1939B7',
																cursor: 'pointer',
																fontStyle: 'italic',
															}}
															onClick={() => {
																setUpdateHistory(order.updatedOrderDetail)
																setOrderDetail(order)
																setShowBackdrop(true)
															}}>
															Lịch sử chỉnh sửa
														</Typography>
													)}
												</Box>

												<Box sx={{ p: 0 }}>
													<Typography sx={{ fontSize: '15px' }}>
														<b>Khối lượng: </b>
														{order.detail.quantity}kg - <b>Tiền: </b>
														{order.detail.totalPrice.toLocaleString()}đ{' '}
														{order.detail.payment === 'transfer' && (
															<span style={{ color: mainGreen, fontWeight: 'bold' }}>(Chuyển khoản)</span>
														)}{' '}
														{order.detail.app && <span style={{ color: mainRed, fontWeight: 'bold' }}>(App)</span>}
													</Typography>
													<Typography sx={{ fontSize: '15px' }}>
														<b>Thông tin: </b>
														{order.detail.detail && (
															<span
																dangerouslySetInnerHTML={{
																	__html: transformDetailWithPhone(order.detail.detail),
																}}></span>
														)}
													</Typography>
													{order.detail.tag?.map((tag, index) => {
														return (
															<Typography
																sx={{
																	display: 'inline-block',
																	fontSize: '12px',
																	padding: '2px 10px',
																	borderRadius: '10px',
																	color: '#fff',
																	background: `${tag.color}`,
																	mr: 1,
																}}
																key={index}>
																{tag.name}
															</Typography>
														)
													})}
													<Box>
														{order.detail.photoAttach.map((photo, index) => {
															return (
																<Fragment key={index}>
																	<img
																		loading='lazy'
																		src={photo}
																		onClick={(e) => {
																			e.stopPropagation()
																			openImageViewer(photo)
																		}}
																		width='30'
																		height='30'
																		style={{
																			marginRight: '8px',
																			marginTop: '5px',
																			cursor: 'pointer',
																		}}
																		alt=''
																	/>
																</Fragment>
															)
														})}
													</Box>
												</Box>
											</Card>
										)
									})}
						</Box>
					</Box>
				</Box>
			)}
		</UserLayout>
	)
}
